export default (error) => {
  /* eslint-disable no-console */
  console.log("RouterOnError", error, error.message);

  if (/loading (\w* )?chunk \d* failed./i.test(error.message)) {
    window.location.reload();
  }
};
